import { FileSpreadsheet } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { PageShell } from '@/components/layout/PageShell'
import { StructuredIngestPage } from '@/features/structured-ingest/StructuredIngestPage'
import { useCaseContext } from '@/pages/cases/CaseContext'

export default function CaseStructuredIngestPage() {
  const { t } = useTranslation()
  const { caseId } = useCaseContext()

  return (
    <PageShell
      layout="padded"
      icon={FileSpreadsheet}
      title={t('tableMapping.page.title')}
      summary={t('tableMapping.page.summary')}
    >
      <StructuredIngestPage caseId={caseId} />
    </PageShell>
  )
}
